<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.68077 0.426538C5.8679 0.159211 6.17369 0 6.5 0H13.5C13.8263 0 14.1321 0.159211 14.3192 0.426538L17.8192 5.42654C17.9369 5.59462 18 5.79483 18 6V19C18 19.5523 17.5523 20 17 20H3C2.44772 20 2 19.5523 2 19V6C2 5.79483 2.06311 5.59462 2.18077 5.42654L5.68077 0.426538ZM7.02066 2L4 6.31522V18H16V6.31522L12.9793 2H7.02066Z" fill="#858E97"/>
        <path d="M10 9C11.1046 9 12 8.10457 12 7C12 5.89543 11.1046 5 10 5C8.89543 5 8 5.89543 8 7C8 8.10457 8.89543 9 10 9Z" fill="#858E97"/>
    </svg>
</template>

<script>
export default {
    name: 'IconBooking',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
